module.exports = __webpack_public_path__ + "assets/img/u5e706f843525a.4c7862cc.png";